import React, {PureComponent} from 'react';
import {NavLink} from 'react-static';
import {NavigationBar} from '../components/NavigationBar/NavigationBar';
import {TextButton} from '../components/TextButton';
import facebook from '../../public/images/icons8-facebook-old.svg';
import {Spacer} from '../components/Spacer';

export class Navigation extends PureComponent {

    render = () => {
        return (
            <div className="navigation-wrapper">
                <NavigationBar>
                    <NavLink to="/" style={{
                        textDecoration: 'none'
                    }}>
                        <TextButton style={{
                            textTransform: 'none',
                            borderTop: '4px solid #00008f',
                            borderBottom: '4px solid #00008f',
                            lineHeight: '8px'
                        }}>Asbest
                            <span style={{color: 'black'}}>krachten.nl</span>
                        </TextButton>
                    </NavLink>
                    <Spacer/>
                    <NavLink to="https://www.facebook.com/Asbestkrachten/" target="_blank">
                        <img src={facebook}/>
                    </NavLink>
                </NavigationBar>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// /Users/stephan/skelware/savot/src/sections/Navigation.jsx